import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ThankyouMessage from '../../blocks/Thankyou/MainMessage';
import ThankyouSummary from '../../blocks/Thankyou/ThankyouSummary';
import ItemsOnTheirWay from '../../blocks/Thankyou/ItemsOnTheirWay';
import store from '../../store';
import messages from '../../i18n';
import CreateAccountWithPassword from '../../blocks/Checkout/CreateAccountWithPassword';
import ProviderWrapper from '../../provider';
import { purpleTheme } from '../../themes/default';

const locale = 'en-US';
const thankyouContainer = document.getElementById('thankyou');
const queryClient = new QueryClient();
if (thankyouContainer) {
  const thankyouRoot = createRoot(thankyouContainer);
  thankyouRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <ThankyouMessage />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const itemsOnTheirWayContainer = document.getElementById('items-on-their-way');
if (itemsOnTheirWayContainer) {
  const itemsOnTheirWayRoot = createRoot(itemsOnTheirWayContainer);
  itemsOnTheirWayRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <ItemsOnTheirWay />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const thankyouSummaryContainer = document.getElementById('thankyou-summary');
if (thankyouSummaryContainer) {
  const thankyouSummaryRoot = createRoot(thankyouSummaryContainer);
  thankyouSummaryRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <ProviderWrapper>
          <QueryClientProvider client={queryClient}>
            <ThankyouSummary />
          </QueryClientProvider>
        </ProviderWrapper>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const accountCreationContainer = document.getElementById('account-creation');
if (accountCreationContainer) {
  const accountCreationRoot = createRoot(accountCreationContainer);
  accountCreationRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale="en"
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <CreateAccountWithPassword />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}
